var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-alert',{class:_vm.isTopLine?'topNote':'',attrs:{"title":"","type":"warning"}},[_c('div',{staticClass:"importantNote"},[_c('i',{staticClass:"iconfont icon-kaiqi f16 col_FEAF0D mr5"}),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }